import config from 'devextreme/core/config';

export const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjI2ZDBiNGFmLTY3OWEtNDBkNS04NjE0LWZhZGQ3MjI2YzIxYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.xuAJasJJOFdYeoQeb9s4W8kdviIIpYilUdXR024Q4adfDb2e7BZQs+jdv1xtn1beLe2x0ALICAIo89I4aEEA45bSQSGTj9a/Kd8njF8gtO3MnC4zj7RiYa35jP/VXJUTV/89ew==';

config({ licenseKey });
